<section class="custom-modal" role="dialog" aria-modal="true" aria-labelledby="from-app-queue-title">
  <header class="modal-header">
    <h2 id="from-app-queue-title" class="modal-title">Processing Queue</h2>
    <button type="button" class="icon-button" aria-label="Close" (click)="onClose()">
      <app-display-icon [icon]="icons.closeOutline"></app-display-icon>
    </button>
  </header>

  <div class="modal-body">
    @if (isLoading()) {
      <p class="queue-status">Loading messages from the processing queue…</p>
    } @else if (items().length === 0) {
      <p class="queue-status">Nothing is waiting in the queue.</p>
    } @else {
      <p class="queue-status">{{ items().length }} message{{ items().length === 1 ? '' : 's' }} waiting to be processed.</p>
      <table class="queue-table">
        <thead>
          <tr>
            <th scope="col">Store</th>
            <th scope="col">Event type</th>
            <th scope="col">Message ID</th>
          </tr>
        </thead>
        <tbody>
          @for (item of items(); track item.storeId + '|' + item.id) {
            <tr>
              <td>{{ item.storeName }}</td>
              <td>{{ item.type }}</td>
              <td>{{ item.id }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

  <footer class="modal-footer">
    <app-shared-button [colour]="'primary'" [disabled]="isLoading()" (buttonClicked)="onRefresh()">
      Refresh
    </app-shared-button>
    <app-shared-button [fill]="true" (buttonClicked)="onClose()">
      Close
    </app-shared-button>
  </footer>
</section>
